// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HO5J","index":"styles_index__2JpV2"};